/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable max-len */
// /* eslint-disable indent */
// /* eslint-disable no-unused-vars */
import { LeadDetailsContainer } from "../../../../components/LeadDetailsContainer";
import React, { useState, useEffect } from "react";
import {
  Spin,
  Button,
  Modal,
  Radio,
  Space,
  Input,
  message,
  List,
  Descriptions,
  Menu,
  Row,
  Col,
  Layout,
  Text,
  Form,
  Popconfirm,
  Select,
} from "antd";
import Heading from "../../../../components/Heading";
import urls from "../../../../api/urls";
import API from "../../../../api";
import { useParams, useLocation } from "react-router";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";
import "./style.scss";
import { customerOnboardingAPI } from "../../../../api/LeadApi";
import {
  UserOutlined,
  FileTextOutlined,
  BankOutlined,
} from "@ant-design/icons";
import DetailsViewer from "../../../../components/MenuLayotView";
import useCustomNavigate from "../../../../components/customNavigationHook";
const { Sider, Content } = Layout;
function LeadDetails() {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const navigate = useCustomNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState("option1");
  const [loading, setLoading] = useState(false);
  const [leadData, setleadData] = useState([]);
  const [inputText, setInputText] = useState(null);
  const [leadInfo, setLeadInfo] = useState({});
  const [nearestCp, setNearestCp] = useState([]);
  const [selectedCp, setSelectedCp] = useState({});
  const { GET_LEAD_DETAILS, LEAD_APPROVAL, GET_RATE_CARD_APPROVAL } = urls;
  let params = useParams();
  const history = useLocation();
  const rejectList = [
    {
      label: "Conflict with existing CP Network",
      value: "Conflict with existing CP Network",
    },
    {
      label: "Lack of commitment enthusiasm",
      value: "Lack of commitment enthusiasm",
    },
    {
      label: "Failed to pass due diligence check",
      value: "Failed to pass due diligence check",
    },
    {
      label: "Lack of industry experience",
      value: "Lack of industry experience",
    },
    {
      label: "Insufficient financial resources",
      value: "Insufficient financial resources",
    },
    { label: "others", value: "others" },
  ];

  useEffect(() => {
    getLeadDataById();
  }, []);

  useEffect(() => {
    if (
      leadInfo?.reference === "MARKETING" &&
      leadInfo?.customerType === "CLIENT"
    ) {
      getNearestCp();
    }
  }, [leadInfo]);

  const getNearestCp = async () => {
    const address = leadInfo?.addresses?.find((e) => e?.type === "gstAddress");
    const response = await customerOnboardingAPI.getNearestCpList(
      address?.postalCode || leadInfo?.pincode
    );
    if (response?.status) {
      let data = response?.response?.data?.filter(
        (item) => item?.prospayCustId
      );
      setNearestCp(
        data?.map((item) => ({
          label: item?.aliasCompanyName,
          value: item?.branchId,
          cpId: item?.cpId,
          companyId: item?.branchId,
          prospayCustId: item?.prospayCustId,
        }))
      );
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const getLeadDataById = async () => {
    try {
      setLoading(true);

      // const response = await API.Api(
      //   `${GET_LEAD_DETAILS}/${params?.leadId}`
      // ).getWithUserNPremiseHeader();
      const response = await customerOnboardingAPI.getLeadById(params?.leadId);

      if (!response.status) {
        throw new Error(response?.response?.data?.message || "Network error");
      }

      const temp = response.response.data;
      setLeadInfo(temp);

      const {
        basicDetail,
        businessDetail,
        kycDocuments,
        agreements,
        addresses,
        documents,
        bankDetails,
        contactNumbers,
        emails,
        contacts,
      } = temp;

      const formattedBasicDetail = {
        CpName: temp?.organizationName,
        CreatedBy: temp?.createdUserName,
        nameOfOwner: businessDetail?.nameOfOwner,
        phoneNumber: contactNumbers?.[0]?.number,
        emailId: temp?.emails?.[0]?.email,
        Remarks: temp?.remark,

        cpType: temp?.cpType,
        addressLine1: addresses?.[0]?.line1,
        addressLine2: addresses?.[0]?.line2,
        PinCode: addresses?.[0]?.postalCode || temp?.pincode,
      };

      const gstNo =
        kycDocuments?.find((doc) => doc.idType === "GST")?.idNumber || null;
      const panNumber =
        kycDocuments?.find((doc) => doc.idType === "PAN")?.idNumber || null;
      const adharNo =
        kycDocuments?.find((doc) => doc.idType === "AADHAR")?.idNumber || null;
      const tanNo =
        kycDocuments.find((doc) => doc.idType === "TAN")?.idNumber || null;
      const billingAddress = addresses?.find(
        (add) => add?.type?.toLowerCase() === "billing"
      );
      const collectionAddress = addresses?.find(
        (add) => add?.type?.toLowerCase() === "office"
      );

      const bankDetail = {};
      bankDetails?.map((item, i) => {
        bankDetail[`accountHolderName${i + 1}`] = item.accountHolderName;
        bankDetail[`accountNumber${i + 1}`] = item.accountNumber;
        bankDetail[`ifscCode${i + 1}`] = item.ifscCode;
      });

      const formattedCompanyDetail = {
        companyName: businessDetail?.companyName,
        gstNo: gstNo,
        panNumber: panNumber,
        aadharNo: adharNo,
        tanNo: tanNo,
        businessType: businessDetail?.natureOfBusiness,
        businessName: businessDetail?.businessName,
        // phoneNumber: contactNumbers?.[0]?.number,
        // emailId: temp?.emails?.[0]?.email,
        //...bankDetails,
      };

      const formattedOnlyCompanyDeatails = {
        CompanyName: temp?.organizationName,
        CreatedBy: temp?.createdUserName,
        nameOfOwner: businessDetail?.nameOfOwner,
        phoneNumber: contactNumbers?.[0]?.number,
        emailId: temp?.emails?.[0]?.email,
        gstNo: gstNo,
        panNumber: panNumber,
        aadharNo: adharNo,
        tanNo: tanNo,
        addressLine1: addresses?.[0]?.line1,
        addressLine2: addresses?.[0]?.line2,
        PinCode: addresses?.[0]?.postalCode || temp?.pincode,
      };

      const formattedOrganizationDetails = {
        clientName: temp?.organizationName,
        CreatedBy: temp?.createdUserName,

        gstNo: gstNo,
        panNumber: panNumber,
        aadharNo: adharNo,
        tanNo: tanNo,
        addressLine1: addresses?.[0]?.line1,
        addressLine2: addresses?.[0]?.line2,
        PinCode: addresses?.[0]?.postalCode || temp?.pincode,
      };

      const formattedBusinessDeatils = {
        contactName: contacts?.[0]?.contactPersonName,
        designatin: contacts?.[0]?.designation,
        department: contacts?.[0]?.departmentName,
        natureOfBusiness: businessDetail?.natureOfBusiness,
        pickupTime: businessDetail?.pickUpTime,
        committedBusiness: businessDetail?.turnOver,
        collectionAddress: `${collectionAddress?.line1 || "N/A"}  ${
          collectionAddress?.line2 || ""
        }  ${collectionAddress?.postalCode || ""}`,
        billingAddress: `${billingAddress?.line1 || "N/A"} ${
          billingAddress?.line2 || ""
        } ${billingAddress?.postalCode || ""}`,
      };

      const formattedAgreementDetail =
        agreements?.map(({ agreementDetails }) => ({
          label: agreementDetails,
          value: agreementDetails,
        })) || [];

      // Update state
      setleadData({
        basicDetail: formattedBasicDetail,
        aggrementDetail: formattedAgreementDetail,
        companyDetail: formattedCompanyDetail,
        bankDetail: bankDetail,
        docDetails: documents,
        organizationDetails: formattedOrganizationDetails,
        businessDeatils: formattedBusinessDeatils,
        onlyCompanyDetails: formattedOnlyCompanyDeatails,
      });
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const reRouteToRateCard = () => {
    // navigate(
    //   `/lead-approval-confirmation/${parmas?.id}/${parmas?.status}/${parmas?.leadId}`,
    //   {
    //     state: {
    //       view: true,
    //     },
    //   }
    // );
    history?.state?.rateCardName?.[0]?.rateCardName
      ? navigate(
          `/lead-cp-approval-confirmation/${params?.status}/${params?.leadId}`,
          {
            state: {
              type: history?.state?.view ? "cp-lead" : "ho-lead",
              rateCards: history?.state?.rateCardName,
              navigateId: id,
            },
          }
        )
      : message.error("Rate Card Not Found.");
  };

  const style = {
    viewDetailsContainer: {
      padding: "10px 10%",
    },
    viewDetailsHeader: {
      height: "35px",
      background: "#f5faff",
      border: "1px solid #bfdcff",
      borderRadius: "5px",
      fontWeight: "700",
      fontSize: "16px",
      color: "#061624",
      paddingLeft: "17px",
    },
    leadDetailsGrid: {},
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setValue(null);
    setInputText(null);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    let val = value === "others" ? inputText : value;

    if (val) {
      setLoading(true);
      let payload = {
        customerId: params?.leadId,
        approvalStatus: "REJECTED",
        remark: val,
      };
      //let res = await API.Api(`${LEAD_APPROVAL}`).putCustomIdHeader(payload);
      const res = await customerOnboardingAPI.putLead(params?.leadId, payload);

      if (res?.status) {
        setLoading(false);
        navigate("/all-approvals", { state: id });
        setIsModalOpen(false);
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error");
        setIsModalOpen(false);
      }
    } else {
      message.error("Please select an option or enter a remark");
    }
  };

  const onRejectChange = (e) => {
    setValue(e.target.value);

    setInputText(null);
  };

  const approveLead = async () => {
    if (
      leadInfo?.reference === "MARKETING" &&
      leadInfo?.customerType === "CLIENT"
    ) {
      setLoading(true);
      let payload = {
        customerId: params?.leadId,
        approvalStatus: "APPROVED",
        companyId: selectedCp?.companyId,
        cpId: selectedCp?.cpId,
        prospayCustId: selectedCp?.prospayCustId,
      };

      const res = await customerOnboardingAPI.putLead(params?.leadId, payload);

      if (res?.status) {
        setLoading(false);
        message.success(res?.response?.data?.message);
        reRouteToRateCard();
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error.");
      }
    } else {
      setLoading(true);
      let payload = {
        customerId: params?.leadId,
        approvalStatus: "APPROVED",
      };
      const res = await customerOnboardingAPI.putLead(params?.leadId, payload);

      if (res?.status) {
        setLoading(false);
        message.success(res?.response?.data?.message);
        reRouteToRateCard();
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error.");
      }
    }
  };

  const id =
    {
      CLIENT: "2",
      COMPANY: "3",
    }[history?.state?.userType] || "1";

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <Modal
        title="Reason for rejection"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Radio.Group onChange={onRejectChange} value={value}>
          <Space direction="vertical">
            {rejectList?.map((item, i) => (
              <Radio key={i} value={item.value}>
                {item.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {value === "others" && (
          <div style={{ marginTop: "20px" }}>
            <div>Remarks</div>
            <TextArea
              className="input-field-style"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              style={{
                borderRadius: "10px",
                minWidth: "250px",
              }}
              placeholder="Please enter remarks"
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
            />
          </div>
        )}
      </Modal>
      <div className="p-2">
        {history?.state?.userType && !history?.state?.view ? (
          <Heading title="Lead Details" navigateTo={"/all-approvals"} id={id} />
        ) : (
          <Heading title="Lead Details" />
        )}

        <div style={{ background: "white" }}>
          {history?.state?.userType === "CLIENT" && (
            <div>
              <LeadDetailsContainer
                dataSources={leadData?.organizationDetails}
                numberOfColumns={4}
                style={style}
                headingText={"Organisation Details"}
              />

              <LeadDetailsContainer
                dataSources={leadData?.businessDeatils}
                numberOfColumns={4}
                style={style}
                headingText={"Business Details"}
              />
            </div>
          )}

          {history?.state?.userType !== "CLIENT" && (
            <>
              <LeadDetailsContainer
                dataSources={
                  history?.state?.userType === "CP"
                    ? leadData?.basicDetail
                    : leadData?.onlyCompanyDetails
                }
                numberOfColumns={4}
                style={style}
                headingText={"Basic Details"}
              />
              {history?.state?.userType === "CP" && (
                <LeadDetailsContainer
                  dataSources={leadData?.companyDetail}
                  numberOfColumns={4}
                  style={style}
                  headingText={"Company Details"}
                />
              )}
              {leadData?.bankDetail &&
                Object.keys(leadData?.bankDetail).length > 0 && (
                  <LeadDetailsContainer
                    dataSources={leadData?.bankDetail}
                    numberOfColumns={3}
                    style={style}
                    headingText={"Bank Details"}
                  />
                )}
            </>
          )}

          <div style={style?.viewDetailsContainer}>
            <div className="view-details-header">Aggrement Details</div>
            <div className="view-details-gride">
              <Descriptions column={1}>
                {leadData?.aggrementDetail?.map((agreement, index) => (
                  <Descriptions.Item
                    key={index}
                    label={index + 1}
                    className="p-05"
                  >
                    {agreement?.label}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </div>
          </div>

          <div style={style?.viewDetailsContainer}>
            <div className="view-details-header">Document Details</div>
            <div className="view-details-gride">
              <Descriptions column={1}>
                {leadData?.docDetails?.map((data, index) => (
                  <Descriptions.Item
                    key={index}
                    label={index + 1}
                    className="p-05"
                  >
                    {data?.docType}:{" "}
                    <a onClick={() => window.open(data?.fileLocationUrl)}>
                      {" "}
                      &nbsp;&nbsp;{data?.fileLocationUrl?.split("/").pop()}
                    </a>
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </div>
          </div>

          <div className="d-flex flex-end mt-1 p-1">
            <Button
              className="btn-style cancel-btn ml-1 w-10"
              onClick={() => {
                history?.state?.view
                  ? window.history.back()
                  : navigate("/all-approvals", { state: id });
              }}
            >
              BACK
            </Button>
            {params?.status?.toLowerCase() === "pending" &&
            !history?.state?.view ? (
              <>
                <Button
                  className="btn-style cancel-btn ml-1"
                  // onClick={cancelTemlate}
                  onClick={() => showModal()}
                >
                  REJECT
                </Button>

                {leadInfo?.reference === "MARKETING" &&
                leadInfo?.customerType === "CLIENT" ? (
                  <Popconfirm
                    icon={null}
                    //width={400}
                    placement="top"
                    title={
                      <Form
                        className="global-form"
                        layout="vertical"
                        form={form}
                        scrollToFirstError={{
                          behavior: "smooth",
                          block: "center",
                          inline: "center",
                        }}
                        //onFinish={addMoreCharge}
                      >
                        <Form.Item
                          name="cpList"
                          label="Select CP"
                          rules={[
                            {
                              required: true,
                              message: "Select CP",
                            },
                          ]}
                        >
                          <Select
                            onChange={(val, key) => {
                              setSelectedCp({
                                companyId: key?.companyId,
                                cpId: key?.cpId,
                                prospayCustId: key?.prospayCustId,
                              });
                            }}
                            options={nearestCp}
                            placeholder="Select"
                            style={{ width: "280px" }}
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </Form.Item>
                      </Form>
                    }
                    onConfirm={() => {
                      approveLead();
                    }}
                    okText="Submit"
                    cancelText="CANCEL"
                  >
                    <Button className="save-btn ml-1">APPROVE</Button>
                  </Popconfirm>
                ) : (
                  <Popconfirm
                    title="Are you sure you want to approve this lead?"
                    onConfirm={() => approveLead()}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      htmlType="submit"
                      className="save-btn  ml-1"
                      id="saveNContinue"
                    >
                      APPROVE
                    </Button>
                  </Popconfirm>
                )}
              </>
            ) : params?.status?.toLowerCase() === "approved" ? (
              <Button
                htmlType="submit"
                className="save-btn ml-1"
                onClick={() => reRouteToRateCard()}
              >
                GO TO RATE CARD
              </Button>
            ) : (
              ""
            )}
          </div>
          {/* ) : null} */}
        </div>
      </div>
    </Spin>
  );
}

export default LeadDetails;

// /**
//  * CP Lead Onboarding Page Component with Sidebar Navigation
//  * @param {Object} data - CP Lead data object
//  */
// const CPLeadDetails = () => {
//   const data = {
//     basicDetail: {
//       leadName: "Manas2025-02-0411:10:29.444278469",
//       nameOfOwner: "Kiran KV",
//       phoneNumber: 9089898978,
//       emailId: "kirankv1@gmail.com",
//       Remarks: null,
//       cpName: "HSR CP KV",
//       cpType: "Booking",
//       addressLine1: "HSR CP",
//       addressLine2: null,
//       PinCode: 560010,
//     },
//     aggrementDetail: [
//       {
//         label:
//           "SMILE does not offer any insurance cover for the shipments and insist to customer to hand over insured goods for transportation under the consignor insurance. In the event of any loss, theft and damage of shipment maximum liability of SMILE is up to provision of COF only.",
//         value:
//           "SMILE does not offer any insurance cover for the shipments and insist to customer to hand over insured goods for transportation under the consignor insurance. In the event of any loss, theft and damage of shipment maximum liability of SMILE is up to provision of COF only.",
//       },
//       {
//         label:
//           "In case of loss, theft, damage and mishandling of booked consignment maximum liability of the Company/ Franchisee shall not be exceeding to the sum equivalent to ten times of freight charges for un-insured documents and five times of freight charges for un-Insured parcels, in any case.",
//         value:
//           "In case of loss, theft, damage and mishandling of booked consignment maximum liability of the Company/ Franchisee shall not be exceeding to the sum equivalent to ten times of freight charges for un-insured documents and five times of freight charges for un-Insured parcels, in any case.",
//       },
//     ],
//     companyDetail: {
//       companyName: "Cuatrogen PVT Limited",
//       gstNo: null,
//       panNumber: null,
//       adharNo: null,
//       businessType: null,
//       businessName: null,
//       // bankDetails: [
//       //   {
//       //     companyBankId: null,
//       //     accountHolderName: "KIRAN",
//       //     accountNumber: "588487489784949480",
//       //     ifscCode: "KADJ0KSJ280",
//       //   },
//       // ],
//     },
//   };
//   const [selectedMenu, setSelectedMenu] = useState("basic");

//   if (!data) return <Text type="danger">No Data Available</Text>;

//   const menuItems = [
//     { key: "basic", icon: <UserOutlined />, label: "Basic Details" },
//     {
//       key: "agreement",
//       icon: <FileTextOutlined />,
//       label: "Agreement Details",
//     },
//     { key: "company", icon: <BankOutlined />, label: "Company Details" },
//   ];

//   return (
//     <div className="p-2">
//       <Heading title="Lead Details" />
//       <Layout
//         style={{ minHeight: "100vh", backgroundColor: "#f0f2f5", padding: 20 }}
//       >
//         <Row gutter={24}>
//           {/* Sidebar Navigation */}
//           <Col xs={24} sm={8} md={6}>
//             <Sider
//               width="100%"
//               style={{
//                 background: "#fff",
//                 borderRadius: 10,
//                 boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//               }}
//             >
//               <Menu
//                 mode="inline"
//                 selectedKeys={[selectedMenu]}
//                 onClick={(e) => setSelectedMenu(e.key)}
//                 style={{ borderRadius: 10 }}
//               >
//                 {menuItems.map((item) => (
//                   <Menu.Item key={item.key} icon={item.icon}>
//                     {item.label}
//                   </Menu.Item>
//                 ))}
//               </Menu>
//             </Sider>
//           </Col>

//           {/* Content Section */}
//           <Col xs={24} sm={16} md={18}>
//             <Content>
//               {selectedMenu === "basic" && (
//                 <DetailsViewer title="Basic Details" data={data.basicDetail} />
//               )}
//               {selectedMenu === "agreement" && (
//                 <DetailsViewer
//                   title="Agreement Details"
//                   data={data.aggrementDetail}
//                 />
//               )}
//               {selectedMenu === "company" && (
//                 <DetailsViewer
//                   title="Company Details"
//                   data={data.companyDetail}
//                 />
//               )}
//             </Content>
//           </Col>
//         </Row>
//       </Layout>
//     </div>
//   );
// };

// export default CPLeadDetails;
